import owd from 'owd/owd';

export default class MainMenu extends owd.Component {
	init() {
        this.injectButtons();
		this.bind();
	}
    
    injectButtons() {
        this.$element.find('.menu > .menu-item').each((i, el) => {
            el = $(el);
            
            el.html((i, oldHTML) => {
                return `${oldHTML}
                        <button class="button button--menu">
                            <span class="button-icon"></span>
                            <span class="visuallyhidden">Rozwiń submenu</span>
                        </button>`;
            });
        });
    }
    
    removeButtons() {
        
    }

	bind() {
        this.on('click', '.button--menu', (e) => {
            const target = $(e.currentTarget);
            const targetParent =  target.parent();
            const subMenu = targetParent.find('.sub-menu');
            
            if(subMenu.length > 0) {
                subMenu.toggleClass('is-visible');
                target.toggleClass('is-expanded');
            }
        });
        /*this.on('resize', this.dom.$window, (e) => {
            if(window.matchMedia('(max-width: 1023px)').matches) {
                
            } else {
                
            }
        });*/
    }

    destroy() {
        super.destroy();
    }
}

owd.registerComponent('main-menu', {
	component: MainMenu
});
